import React from 'react';

const HelpDefault = () => (
    <div>
        <h2>Pagalba</h2>
        <p>Čia bus pagalbos informacija.</p>
    </div>
);

export default HelpDefault;
